module.exports = __webpack_public_path__ + "media/images/markers/puc-2x-68bf7015864a2ca8270c52aee346d092.png";